import React, { useEffect, useState } from 'react';

export default function LimitDropdown({ value, onChange, options = [10, 50, 100], className = '' }) {
  const [localValue, setLocalValue] = useState(value || options[0]);

  useEffect(() => {
    if (value !== undefined && value !== localValue) setLocalValue(value);
  }, [value]);

  const handleChange = (e) => {
    const next = parseInt(e.target.value, 10);
    setLocalValue(next);
    if (onChange) onChange(next);
  };

  return (
    <select
      value={localValue}
      onChange={handleChange}
      className={`border rounded px-3 py-1 text-sm bg-white ${className}`}
      aria-label="Items per page"
    >
      {options.map((o) => (
        <option key={o} value={o}>{o} / page</option>
      ))}
    </select>
  );
}
